<template>
    <Box title="巡检计划实施" :SearchParams="tabsIndex===0?IsSee:IsSeeSecond" @SearchParams="tabsIndex===0?IsSee=true:IsSeeSecond=true">
        <van-tabs @click="propconfirm" swipeable background="rgba(0,0,0,0)" line-width="20px" v-model="tabsIndex">
            <van-tab :title="'未执行('+Total+'台)'">
                <LoadingFooter v-model="loading" :finished="finished" @load="onLoad" @scroll="IsSee=false">
                    <div class="ArrayItems">
                        <div class=" items" v-for="item in list" @click="Preventionout(item,'Y')">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <div>
                                        <span class="ellipsis">{{item.JHMC}}</span>
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                    <div>
                                        <div>
                                            <p>指定日期:</p>
                                            <p>巡检科室:</p>
                                            <p>巡检周期:</p>
                                            <p>执行人:</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.ZDRQ}}</p>
                                            <p class="ellipsis">{{item.KSMC}}</p>
                                            <p class="ellipsis">{{item.JCDWMC}}</p>
                                            <p class="ellipsis">{{item.FZRXM}}</p>
                                        </div>
                                        <div class="button">
                                            <div>执行计划</div>
                                            <div @click.stop="stop(item)">终止计划</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span>本次巡检时间</span>
                                <span>{{item.BCJCRQ}}</span>
                            </div>
                        </div>
                    </div>

                </LoadingFooter>
            </van-tab>
            <van-tab :title="'已执行('+TotalSecond+'台)'">
                <LoadingFooter v-model="loadingSecond" :finished="finishedSecond" @load="onLoadSecond" @scroll="IsSeeSecond=false">
                    <div class="ArrayItems">
                        <div class="items" v-for="item in listSecond" @click="Preventionout(item,'N')">
                            <div>
                                <img src="@/assets/img/Icon_1.png" />
                                <div>
                                    <div>
                                        <span class="ellipsis">{{item.JHMC}}</span>
                                        <img src="../../assets/img/right.png" />
                                    </div>
                                    <div>
                                        <div>
                                            <p>指定日期:</p>
                                            <p>巡检科室:</p>
                                            <p>巡检周期:</p>
                                            <p>执行人:</p>
                                        </div>
                                        <div>
                                            <p class="ellipsis">{{item.ZDRQ}}</p>
                                            <p class="ellipsis">{{item.KSMC}}</p>
                                            <p class="ellipsis">{{item.JCDWMC}}</p>
                                            <p class="ellipsis">{{item.FZRXM}}</p>
                                        </div>
                                        <div class="button">
                                            <div>查看</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <span>本次巡检时间</span>
                                <span>{{item.BCJCRQ}}</span>
                            </div>
                        </div>
                    </div>

                </LoadingFooter>
            </van-tab>
        </van-tabs>
        <transition-group name="fade">
            <div class="menu" v-show="IsSee" key='1'>
                <Field title="计划名称" placeholder="请输入计划名称" @onMessage="value => search.JHMC = value" />
                <Field title="巡检科室" placeholder="请选择" type='manufacturer' name='departmentList' @manuconfirm="search.JCKS=arguments[0].a" />

                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.StarDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition-group>
        <transition-group name="fade">
            <div class="menu" v-show="IsSeeSecond" key='1'>
                <Field title="计划名称" placeholder="请输入计划名称" @onMessage="value => searchSecond.JHMC = value" />
                <Field title="巡检科室" placeholder="请选择" type='manufacturer' name='departmentList' @manuconfirm="searchSecond.JCKS=arguments[0].a" />

                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => searchSecond.StarDate = value" />
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => searchSecond.EndDate = value" />
                <div class="search" @click="serach">查询</div>
            </div>
        </transition-group>
    </Box>
</template>

<script>
    import {
        ExistsEdorIng
    } from '../../../tool/api/api.js'
    import {
        Tab,
        Tabs
    } from 'vant'
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'PollingimplementList',
        data() {
            return {
                search: {
                    JHMC: null,
                    JCKS: null,
                    StarDate: null,
                    EndDate: null,
                },
                searchSecond: {
                    JHMC: null,
                    JCKS: null,
                    StarDate: null,
                    EndDate: null,
                },
                loading: true,
                finished: false,
                list: [],
                touchStartY: 0,
                IsSee: false,
                page: 10,
                Total: 0,
                page: 1,
                tabsIndex: 0, //选项卡默认选中
                listSecond: [], //已执行列表
                loadingSecond: true,
                finishedSecond: false,
                pageScond: 1,
                TotalSecond: 0,
                touchStartYSecond: 0, //已执行滚动条滚动数值
                IsSeeSecond: false, //已执行 是否展示


            }
        },
        components: {
            Box,
            Field,
            LoadingFooter,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
        },
        mounted() {
            this.list = [];
            this.page = 1;
            this.loadDataDefault();
        },
        methods: {
            onScroll(value) {
                if (value > this.touchStartY) {
                    this.touchStartY = value
                    this.IsSee = false;
                } else if ((this.touchStartY - value) > 200) {
                    this.touchStartY = value
                    this.IsSee = true;
                }
            },
            serach() {
                if (this.tabsIndex === 0) {
                    this.loading=true,
                    this.finished=false,
                    this.IsSee=false;
                    this.list = [];
                    this.page = 1;
                    this.loadDataDefault();
                } else {

                    this.loadingSecond=true,
                    this.finishedSecond=false,

                    this.IsSeeSecond=false;
                    this.listSecond = [];
                    this.pageScond = 1;
                    this.loadDataSecondDefault();
                }
            },
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },
            stop(item) { //终止计划
                this.$Dialog.confirm({
                    message: '确定终止?'
                }).then(() => {
                    this.$post('api/QualityControl/StopPlan', {
                        JHDH: item.JHDH,
                        KSBH: item.KSBH,
                        JHJCRQ: item.JHJCRQ,
                        GKHM: this.$UserInfo.UserId,
                        STORE: this.$UserInfo.StoreCode
                    }).then(result => {
                        this.$Toast(result.Msg);
                        if (result.Status) {
                            setTimeout(x => {
                                this.list = [];
                                this.loadDataDefault()
                            }, 2000);
                        }
                    })
                }).catch(() => {})
            },
            loadDataDefault() {
                this.$post('api/QualityControl/XJSSList', {
                    ZXZT: 0,
                    JHDH: '',
                    ZXR: '',
                    GKHM: this.$UserInfo.UserId,
                    JHMC: this.search.JHMC,
                    JCKS: this.search.JCKS,
                    StarDate: this.search.StarDate,
                    EndDate: this.search.EndDate,
                    pageIndex: this.page,
                    pageSize: 10
                }).then(result => {
                    this.Total = result.Total;
                    for (let i = 0; i < result.rows.length; i++) {
                        this.list.push(result.rows[i]);
                    }
                    if (this.page * 10 > this.Total) {
                        this.loading = false;
                        this.finished = true;
                    } else this.loading = false;
                })
            },
            /*************************已执行**************************************/
            propconfirm() {
                if(this.tabsIndex === 0){
                    this.loading=true;
                    this.finished=false;
                    this.list = [];
                    this.page = 1;
                    this.loadDataDefault();
                }else{
                    this.listSecond = [];
                    this.pageScond = 1;
                    this.loadingSecond=true;
                    this.finishedSecond=false;
                    this.loadDataSecondDefault()
                }
            },
            loadDataSecondDefault() {
                this.$post('api/QualityControl/XJSSList', {
                    ZXZT: 1,
                    JHDH: '',
                    ZXR: '',
                    GKHM: this.$UserInfo.UserId,
                    JHMC: this.searchSecond.JHMC,
                    JCKS: this.searchSecond.JCKS,
                    StarDate: this.searchSecond.StarDate,
                    EndDate: this.searchSecond.EndDate,
                    pageIndex: this.pageScond,
                    pageSize: 10
                }).then(result => {
                    this.TotalSecond = result.Total;
                    for (let i = 0; i < result.rows.length; i++) {
                        this.listSecond.push(result.rows[i]);
                    }
                    if (this.pageScond * 10 > this.TotalSecond) {
                        this.loadingSecond = false;
                        this.finishedSecond = true;
                    } else this.loadingSecond = false;
                })
            },
            onLoadSecond() {
                if (!this.loadingSecond && !this.finishedSecond) {
                    this.pageScond += 1;
                    this.loadDataSecondDefault();
                }
            },
            onScrollSecond(value) {
                if (value > this.touchStartYSecond) {
                    this.touchStartYSecond = value
                    this.IsSeeSecond = false;
                } else if ((this.touchStartYSecond - value) > 200) {
                    this.touchStartYSecond = value
                    this.IsSeeSecond = true;
                }
            },
            Preventionout(item, state) { //判断跳转
                ExistsEdorIng(2, state, 'PollingimplementDefault_XS', item);
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu {

        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        margin-top: 100px;

        .items {
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;

            span {
                flex: 1;
            }

            input {
                width: 215px;
                font-size: 29px;
                text-align: center;

                &::-webkit-input-placeholder {
                    color: #858585;
                }
            }
        }

        .search {
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;

        &>div {
            &:first-child {
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;

                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }

                &>div {
                    &:nth-child(2) {
                        margin-left: 16px;
                        flex: 1;

                        &>div {
                            display: flex;

                            &:first-child {
                                margin-bottom: 18px;
                                display: flex;

                                span:first-child {
                                    color: $TEXT-DARK-COLOR;
                                    font-weight: bold;
                                    font-size: 32px;
                                    flex: 1;
                                    width: 208px;
                                }

                                span:nth-child(2) {
                                    color: $TEXT-DARK-COLOR;
                                    font-size: 28px;
                                    margin-left: 10px;
                                    width: 158px;
                                    text-align: right;
                                }

                                img {
                                    width: 32px;
                                    height: 32px;
                                    margin-left: 10px;
                                }
                            }

                            &:nth-child(2) {
                                p {
                                    color: #999;
                                    font-size: 26px;
                                    line-height: 45px;
                                    height: 45px;
                                }

                                &>div:nth-child(2) {
                                    p {
                                        width: 200px;
                                    }
                                }
                            }
                        }

                        .button {
                            margin-left: 10px;
                            margin-top: 20px;

                            div {
                                width: 152px;
                                height: 60px;
                                border-radius: 30px;
                                background: $THEME-COLOR;
                                font-size: 26px;
                                color: #fff;
                                text-align: center;
                                line-height: 60px;
                                margin-bottom: 12px;
                            }
                        }
                    }
                }
            }

            &:last-child {
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;

                span {
                    color: #999;
                    font-size: 26px;

                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }

    .listLength {
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;

        span {
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }

    .ArrayItems{
        margin-top:100px;
    }
</style>



// WEBPACK FOOTER //
// src/page/pollingimplementList_XS/pollingimplementList.vue